<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout v-resize="onResize" column>
    <v-data-table
      :headers="headers"
      :items="data"
      :pagination.sync="pagination"
      :hide-headers="isMobile"
      :class="{ mobile: isMobile }"
      :item-key="itemKey"
      :total-items="totalItems"
      rows-per-page-text="每页行数"
      no-results-text="没有找到结果"
    >
      <template v-slot:items="props">
        <tr
          v-if="!isMobile"
          :key="props.index"
          :active="props.selected"
        >
          <td v-for="header in headers" :key="header.value">
            <template v-if="header.value==='settings'">
              <div style="display: flex;justify-content: center">
                <v-btn
                  v-if="!header.hideEdit"
                  style="margin:0 5px !important;"
                  color="info"
                  small
                  @click="editButtonClicked(props.item)"
                >
                  编辑
                </v-btn>
                <v-btn
                  style="margin:0 5px !important;"
                  color="success"
                  outline
                  small
                  @click="addButtonClicked(props.item)"
                >
                  增加发票
                </v-btn>
              </div>
            </template>
            <template v-else>
              {{
                header.formatter
                  ? header.formatter(props.item[header.value])
                  : props.item[header.value]
              }}
            </template>
          </td>
        </tr>
        <!--手机端-->
        <tr
          v-else
          :key="props.item[itemKey]"
          :active="props.selected"
          @click="props.selected = !props.selected"
        >
          <td>
            <v-container fluid grid-list-md class="xn-form pa-0">
              <v-layout wrap>
                <v-flex v-for="header in headers.filter(h => h.value!=='settings')" :key="header.value" xs12>
                  <p class="datatable-title">{{ header.text }}</p>
                  <p>
                    {{
                      header.formatter
                        ? header.formatter(props.item[header.value])
                        : props.item[header.value]
                    }}
                  </p>
                </v-flex>
                <v-flex v-for="header in headers.filter(h => h.value==='settings')" :key="header.value" xs12>
                  <p class="datatable-title">{{ header.text }}</p>
                  <div style="display: flex;">
                    <v-btn
                      v-if="!header.hideEdit"
                      style="margin:0 5px !important;"
                      color="info"
                      small
                      @click="editButtonClicked(props.item)"
                    >
                      编辑
                    </v-btn>
                    <v-btn
                      style="margin:0 5px !important;"
                      color="success"
                      outline
                      small
                      @click="addButtonClicked(props.item)"
                    >
                      增加发票
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </td>
        </tr>
        <!--手机端-->
      </template>
      <template v-slot:no-data>
        <div v-if="!isLoading">
          {{ noDataText }}
        </div>
        <div v-else class="text-xs-center">
          <v-progress-circular indeterminate></v-progress-circular>
        </div>
      </template>
    </v-data-table>
  </v-layout>
</template>

<script>
  import {EventBus} from "../event";

  export default {
    name: "DataTable2",
    props: {
      headers: {
        type: Array,
        required: true
      },
      fetchData: {
        type: Function,
        required: true
      },
      itemKey: {
        type: String,
        required: true
      },
      sortBy: {
        type: String,
        required: true
      }
    },
    methods: {
      changeSort(column) {
        if (this.pagination.sortBy === column && !this.pagination.descending) {
          this.pagination.descending = true;
        } else if (
          this.pagination.sortBy === column &&
          this.pagination.descending
        ) {
          this.pagination.sortBy = null;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
      },
      onResize() {
        this.isMobile = window.innerWidth < 769;
      },
      editButtonClicked(item) {
        this.$emit("editButtonClicked", item);
      },
      addButtonClicked(item) {
        this.$emit("addButtonClicked", item);
      },
      refresh() {
        this.isLoading = true;
        this.fetchData(
          this.pagination,
          this.searchText,
          (totalItems, data) => {
            this.noDataText = "没有找到结果";
            this.isLoading = false;
            this.data = data;
            this.totalItems = totalItems;
          },
          error => {
            if (!error.response) {
              this.noDataText = "网络连接失败";
            } else {
              if (error.response.status / 100 === 4) {
                this.noDataText = "无效请求";
              } else if (error.response.status / 100 === 5) {
                this.noDataText = "服务器错误";
              } else {
                this.noDataText = "未知错误";
              }
            }
            this.data = [];
            this.isLoading = false;
          }
        );
      },
    },
    data: () => ({
      noDataText: "",
      data: [],
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: null
      },
      isMobile: false,
      totalItems: 0,
      isLoading: true,
    }),
    watch: {
      pagination: {
        handler() {
          this.refresh();
        },
        deep: true
      },
    },
    created() {
      EventBus.$on("refresh", () => {
        this.refresh();
      });
      this.pagination.sortBy = this.sortBy;
    }
  }
</script>

<style scoped>
  .mobile {
    color: #333;
  }

  @media screen and (max-width: 768px) {
    .mobile table.v-table tr {
      max-width: 100%;
      position: relative;
      display: block;
    }

    .mobile table.v-table tr:nth-child(odd) {
      border-left: 6px solid deeppink;
    }

    .mobile table.v-table tr:nth-child(even) {
      border-left: 6px solid cyan;
    }

    .mobile table.v-table tr td {
      display: flex;
      width: 100%;
      border-bottom: 1px solid #f5f5f5;
      height: auto;
      padding: 10px;
    }

    .mobile table.v-table tr td ul li:before {
      content: attr(data-label);
      padding-right: 0.5em;
      text-align: left;
      display: block;
      color: #999;
    }

    .v-datatable__actions__select {
      width: 50%;
      margin: 0px;
      justify-content: flex-start;
    }

    .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
      background: transparent;
    }
  }

  .datatable-title {
    font-weight: bold;
    color: #aaaaaa;
    margin-bottom: 5px;
  }
</style>
